import React from 'react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewSuccess = () => {
  const notify = () =>
    toast(
      <div
        style={{ height: '100%', width: '100%', borderLeft: '5px solid green' }}
      >
        {/* insert your icon here */}
        <span style={{ fontWeight: 'bold', color: '#000' }}>Success</span>{' '}
        Default address update
      </div>
    );
  return (
    <div>
      <button onClick={notify}>Notify!</button>
      <ToastContainer />
    </div>
  );
};

export default NewSuccess;
